export default "__VITE_ASSET__b3efcf12__"